import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';

import { resetPassword } from 'actions/settings';

import { APP_ROOT_SELECTOR } from 'constants/selectors';
import ForgottenPasswordResetModalComponent from './ForgottenPasswordResetModalComponent';

const INITIAL_STATE = {
  complete: false,
  message: undefined,
};

class ForgottenPasswordResetModalContainer extends Component {
  state = { ...INITIAL_STATE }

  constructor(props) {
    // Prevent React Modal from throwing a warning because it doesn't know about the selector
    super(props);
    ReactModal.setAppElement(APP_ROOT_SELECTOR);
  }

  handleRequestClose = () => {
    const { onRequestClose } = this.props;
    const { complete } = this.state;

    if (!complete) {
      return;
    }
    this.setState({ ...INITIAL_STATE });
    onRequestClose();
  }

  handleSubmit = async ({ password }) => {
    const { dispatch, token } = this.props;
    const { isSuccess, message } = await dispatch(resetPassword({ password, token }));
    if (isSuccess) {
      return this.setState({ complete: true, message: 'Password reset!' });
    }
    return this.setState({ message, complete: true });
  }

  render = () => {
    const { isOpen } = this.props;
    const { complete, message } = this.state;
    return (
      <ForgottenPasswordResetModalComponent
        message={message}
        isComplete={complete}
        isOpen={isOpen}
        onRequestClose={this.handleRequestClose}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

export default connect()(ForgottenPasswordResetModalContainer);